import type { EventName } from "@lit/react";
import { ComboBox as ComboBoxElement, type ComboBoxEventMap as _ComboBoxEventMap, } from "@vaadin/combo-box/vaadin-combo-box.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ComboBoxElement, };
export type ComboBoxEventMap<T1> = Readonly<{
    onValidated: EventName<_ComboBoxEventMap<T1>["validated"]>;
    onChange: EventName<_ComboBoxEventMap<T1>["change"]>;
    onInput: EventName<_ComboBoxEventMap<T1>["input"]>;
    onCustomValueSet: EventName<_ComboBoxEventMap<T1>["custom-value-set"]>;
    onSelectedItemChanged: EventName<_ComboBoxEventMap<T1>["selected-item-changed"]>;
    onValueChanged: EventName<_ComboBoxEventMap<T1>["value-changed"]>;
    onInvalidChanged: EventName<_ComboBoxEventMap<T1>["invalid-changed"]>;
    onOpenedChanged: EventName<_ComboBoxEventMap<T1>["opened-changed"]>;
    onFilterChanged: EventName<_ComboBoxEventMap<T1>["filter-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onCustomValueSet: "custom-value-set", onSelectedItemChanged: "selected-item-changed", onValueChanged: "value-changed", onInvalidChanged: "invalid-changed", onOpenedChanged: "opened-changed", onFilterChanged: "filter-changed" } as ComboBoxEventMap<any>;
export type ComboBoxProps<T1> = WebComponentProps<ComboBoxElement<T1>, ComboBoxEventMap<T1>>;
export const ComboBox = createComponent({
    elementClass: ComboBoxElement, events, react: React, tagName: "vaadin-combo-box"
}) as <T1>(props: ComboBoxProps<T1> & React.RefAttributes<ComboBoxElement<T1>>) => React.ReactElement | null;
